import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import styles from './Footer.module.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleNavClick = (e) => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.dotPattern} />
      <div className={styles.footerContent}>
        <motion.div 
          className={styles.footerSection}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Link to="/" onClick={handleNavClick}>
            <img src="/Logo.svg" alt="ReverBeat" style={{ height: '40px', marginBottom: '1rem' }} />
          </Link>
          <p>Transform your music with AI-powered audio processing. Create mesmerizing slowed reverb and fast reverb versions instantly.</p>
          <div className={styles.socialLinks}>
            <a href="https://x.com/ReverBeatPro" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
              </svg>
            </a>
            <a href="https://www.youtube.com/@ReverBeatPro" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"/>
                <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"/>
              </svg>
            </a>
            <a href="https://github.com/EsstafaSoufiane" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/>
              </svg>
            </a>
          </div>
        </motion.div>

        <motion.div 
          className={styles.footerLinksGrid}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <div>
            <h4>Product</h4>
            <ul>
              <li><Link to="/documentation" onClick={handleNavClick}>Documentation</Link></li>
              <li><Link to="/about" onClick={handleNavClick}>About</Link></li>
            </ul>
          </div>

          <div>
            <h4>Resources</h4>
            <ul>
              <li><Link to="/tutorials" onClick={handleNavClick}>Tutorials</Link></li>
              <li><Link to="/blog" onClick={handleNavClick}>Blog</Link></li>
              <li><Link to="/support" onClick={handleNavClick}>Support</Link></li>
              <li><Link to="/donate" onClick={handleNavClick}>Donate</Link></li>
            </ul>
          </div>

          <div>
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy" onClick={handleNavClick}>Privacy Policy</Link></li>
              <li><Link to="/terms" onClick={handleNavClick}>Terms of Service</Link></li>
              <li><Link to="/cookies" onClick={handleNavClick}>Cookie Policy</Link></li>
              <li><Link to="/refund" onClick={handleNavClick}>Refund Policy</Link></li>
              <li><Link to="/affiliate-policy" onClick={handleNavClick}>Affiliate Program Policy</Link></li>
              <li><Link to="/privacy#do-not-sell" onClick={handleNavClick}>Do Not Sell My Info</Link></li>
            </ul>
          </div>
        </motion.div>
      </div>

      <motion.div 
        className={styles.copyright}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        &copy; {currentYear} ReverBeat. All rights reserved.
      </motion.div>
    </footer>
  );
};

export default Footer;
